import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { MeasurementType } from './measurement-type';
export { MeasurementType };
import { measurementTypeSchema } from '@schemas/business-objects/measurement-type';
import { MeasurementFormArray } from './measurement-form-group';

export class MeasurementTypeFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    sequence: SchemaFormControl;
    isScalingReference: SchemaFormControl;
    referenceLength: SchemaFormControl;
    referenceLengthOptions: SchemaFormControl;
    description: SchemaFormControl;
    measurements: MeasurementFormArray;
  };

  declare value: Partial<MeasurementType>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(measurementTypeSchema, MeasurementType, data, options);
  }

  get object(): MeasurementType {
    return new MeasurementType(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'measurements':
        return new MeasurementFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<MeasurementType[]> {
    return MeasurementType.find(filter);
  }

  static async findOne(filter?: any): Promise<MeasurementType | null> {
    return MeasurementType.findOne(filter);
  }

  static async findById(id: number, filter?: any): Promise<MeasurementType> {
    return MeasurementType.findById(id, filter);
  }

  static async create(
    data: Partial<MeasurementType>,
  ): Promise<MeasurementType> {
    return MeasurementType.create(data as any);
  }

  static async updateById(
    id: number,
    updates: Partial<MeasurementType>,
  ): Promise<MeasurementType> {
    return MeasurementType.updateById(id, updates as any);
  }

  static async deleteById(id: number): Promise<boolean> {
    return MeasurementType.deleteById(id);
  }

  async makeScalingReference(): Promise<any> {
    const instance = new MeasurementType(this.getRawValue());
    return instance.makeScalingReference();
  }
}

export class MeasurementTypeFormArray extends PersistedFormArray {
  readonly entityName = 'MeasurementType' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(measurementTypeSchema, MeasurementType, options);
  }

  protected override createItemGroup() {
    return new MeasurementTypeFormGroup();
  }

  get array(): MeasurementType[] {
    return this.controls.map((group: MeasurementTypeFormGroup) => group.object);
  }
}

export class MeasurementTypePersistedArray extends PersistedArray<MeasurementType> {
  readonly entityName = 'MeasurementType' as const;

  constructor(options?: PersistedArrayOptions) {
    super(MeasurementType, options);
  }
}
